import { bootstrap } from '@app/bootstrap'

bootstrap()
